import { render, staticRenderFns } from "./form.vue?vue&type=template&id=85a9ca60&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/borno-cct/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('85a9ca60')) {
      api.createRecord('85a9ca60', component.options)
    } else {
      api.reload('85a9ca60', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=85a9ca60&", function () {
      api.rerender('85a9ca60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/school/form.vue"
export default component.exports